import { Box, InputAdornment, TextField, Typography } from '@mui/material'
import * as React from 'react'
import { Person, Phone, PhoneIphone } from '@mui/icons-material'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useStudyContext } from '../../../Contexts/Modules/StudyModule/SelectedStudyModule'
import { useParams } from 'react-router-dom'

function ContactDetails({
  updateStudy,
  contact,
}: {
  updateStudy: any
  contact: 'Prm' | 'Sec'
}) {
  const { studyQuery, studyEdit, setStudyEdit } = useStudyContext()
  const { loginConfig } = useUserContext()
  const { study_id } = useParams()
  const primSec = contact === 'Sec' ? 'Secondary' : 'Primary'

  return (
    <Box>
      <Typography sx={{ fontWeight: 600 }}>
        {primSec + ' Contact Details'}
      </Typography>
      <TextField
        label="Name"
        value={studyEdit?.[`Study${contact}Name`] || ''}
        margin="normal"
        fullWidth
        onChange={(e: any) =>
          setStudyEdit((s: any) => {
            return { ...s, [`Study${contact}Name`]: e.target.value }
          })
        }
        disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
        onBlur={(e: { target: { value: string | undefined } }) => {
          if (
            e.target.value &&
            studyQuery.data?.[`Study${contact}Name`] !== e.target.value
          ) {
            updateStudy({ [`Study${contact}Name`]: e.target.value })
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Person />
            </InputAdornment>
          ),
        }}
      />
      <TextField
        label="Phone"
        value={studyEdit?.[`Study${contact}Phone`] || ''}
        margin="normal"
        fullWidth
        onChange={(e: any) =>
          setStudyEdit((s: any) => {
            return { ...s, [`Study${contact}Phone`]: e.target.value }
          })
        }
        disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
        onBlur={(e: { target: { value: string | undefined } }) => {
          if (
            e.target.value &&
            studyQuery.data?.[`Study${contact}Phone`] !== e.target.value
          ) {
            updateStudy({ [`Study${contact}Phone`]: e.target.value })
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Phone />
            </InputAdornment>
          ),
        }}
      />
      <TextField
        label="Mobile"
        value={studyEdit?.[`Study${contact}Mobile`] || ''}
        margin="normal"
        fullWidth
        onChange={(e: any) =>
          setStudyEdit((s: any) => {
            return { ...s, [`Study${contact}Mobile`]: e.target.value }
          })
        }
        disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
        onBlur={(e: { target: { value: string | undefined } }) => {
          if (
            e.target.value &&
            studyQuery.data?.[`Study${contact}Mobile`] !== e.target.value
          ) {
            updateStudy({ [`Study${contact}Mobile`]: e.target.value })
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PhoneIphone />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  )
}

export default ContactDetails
